const customerSearch = {
  'customerSearch.placeholder':
    'Search by email, document number or bank account number.',
  'customerSearch.placeholderCardNumber': 'Search by card number',
  'customerSearch.tip':
    'Search by name, document number, email or phone number.',
  'customerSearch.tipV2':
    'Search by email, document number or bank account number.',
  'customerSearch.searchByCardNumber': 'Search by card number',
  'customerSearch.searchUser': 'Search user',
  'customerSearch.search': 'search',
};

export default customerSearch;
